import { Component, OnInit, Renderer2 } from '@angular/core';
import { TreeNode } from 'primeng/api';
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";
import { Store } from '@ngrx/store';
import * as fromStore from '../../../store';
import { NgxUiLoaderService } from "ngx-ui-loader";
import { Subject, combineLatest } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import * as fromFeature from '../../../my-features';
import { RegionService } from 'src/app/services/region.service';
import { ActivatedRoute } from '@angular/router';
import { CryptoService } from '../../../services/crypto.service';
import { PaymentTypeIndex } from '../../../shareModel';

@Component({
  standalone: false,
  selector: 'app-document-pdf',
  templateUrl: './document-pdf.component.html',
  styleUrls: ['./document-pdf.component.css']
})
export class PaymentDocumentPdfComponent implements OnInit {
  private componentDestroyed = new Subject();
  deviceUsageList: TreeNode[];
  summaryList: TreeNode[];
  docNumber: string = '';
  docDetailInfo = {
    Company: '',
    DocNo: '',
    MonthYear: '',
    DocDate: '',
    DocStartDay: '',
    DocEndDay: '',
    DocType: 1,
    Period: '',
    PaymentType: 1,
    isDistributor: false,
    GenerateTime: '',
    CorrNo: '',
  };
  deviceUsageTotal = {
    name: '',
    quantity: 0,
    last_quantity: 0,
    unitprice: 0,
    amount: 0,
  };
  summaryTotal = {
    name: '',
    quantity: 0,
    unitprice: 0,
    amount: 0,
  };
  getMspDocParam = {
    otp: '',
    DocId: 0
  };
  getPaymentInfo = {
    Company: '',
    CompanyName: '',
    Address: '',
    CompanyEmail: '',
    PaymentName: '',
    PaymentAddress: '',
    MinCharge: 0,
    ChargeType: 0,
  };
  getMspRegionParam = {
    otp: '',
    RegionId: []
  };
  isMspLoaded = false;
  show_Doc_Info = false;
  PaymentTypeIndex = PaymentTypeIndex

  constructor(private ngxService: NgxUiLoaderService, private store: Store<fromStore.State>, private regionService: RegionService,
    private cryptoService: CryptoService, private route: ActivatedRoute, private renderer: Renderer2
  ) {
    this.deviceUsageList = [];
    this.summaryList = [];
    this.docNumber = '';

    const regionId = parseInt(this.cryptoService.aesDecrypt(this.route.snapshot.paramMap.get('id')));

    // Msp Data
    combineLatest(this.store.select(fromStore.getIsMsp), this.store.select(fromStore.getCurrentUser))
    .pipe(takeUntil(this.componentDestroyed))
    .subscribe(([getIsMspRes, getCurrentUserRes]) => {
      if (!this.isMspLoaded) {
        this.ngxService.start();
      }
      if ((getIsMspRes !== undefined && getIsMspRes !== null) && (getCurrentUserRes !== undefined && getCurrentUserRes !== null)) {
        // Get IsMsp
        this.isMspLoaded = true;
        const isSystemAdmin = getCurrentUserRes.authority === 2;
        const isAdmin = getCurrentUserRes.authority === 1;
        const isMsp = getIsMspRes;
        if (!isSystemAdmin && isAdmin && !isMsp) {
          this.getMspRegionParam = {
            ...this.getMspRegionParam,
            RegionId: [getCurrentUserRes.RegionId],
          };
        }
        // console.log('document-pdf.component.ts - Get IsMsp', getIsMspRes, getCurrentUserRes);
        
        this.store.dispatch(new fromFeature.GetMspRegionPayment({ ...this.getMspRegionParam }));
        this.ngxService.stop();
      }
    });

    this.store.select(fromStore.getMspRegionPayment).pipe(takeUntil(this.componentDestroyed)).subscribe((res) => {
      if ((res !== undefined && res !== null)) {
        if (res.payment_dic[regionId] !== undefined) {
          res.payment_dic[regionId].map((r) => {
            if (r.MspRegionId === regionId) {
              this.getPaymentInfo.CompanyName = r.Company;
              this.getPaymentInfo.Address = r.Address;
              this.getPaymentInfo.CompanyEmail = r.CompanyEmail;
              this.getPaymentInfo.PaymentName = r.PaymentName;
              this.getPaymentInfo.PaymentAddress = r.PaymentAddress;
              this.getPaymentInfo.MinCharge = r.MinCharge;
              this.getPaymentInfo.Company = r.Company;
              this.getPaymentInfo.ChargeType = r.ChargeType;
            }
          })
        }
      }
    })

    // Get Payment Document
    this.store.select(fromStore.getMspPaymentDocument).pipe(takeUntil(this.componentDestroyed)).subscribe(res => {
      if (res !== null && res !== undefined) {
        this.summaryList = [];
        this.deviceUsageList = [];
        res.deviceUsage.map((d) => {
          if (d.data !== undefined && d.name == undefined ) {
            this.docNumber = res.DocNo;
            this.deviceUsageList.push({
              data: { ...d.data },
              expanded: d.expanded,
              children: Array.isArray(d.children)
                ? d.children.map((c) => ({
                    ...c,
                    data: c.data ? { ...c.data } : c.data,
                  }))
                : d.children
            });

            this.summaryList.push({
              data: { ...d.data },
              expanded: d.expanded,
              // require: d.isDefaultQuantity
            });
            
          } else {
            if (d.type === 0) {
              this.deviceUsageTotal.quantity = d.quantity;
              this.deviceUsageTotal.last_quantity = d.last_quantity;
              this.deviceUsageTotal.name = d.name;
            } else {
              this.summaryTotal.quantity = d.quantity;
              this.summaryTotal.unitprice = d.unitprice;
              this.summaryTotal.amount = d.amount;
              this.summaryTotal.name = d.name;
            }
          }
        });
        // this.deviceUsageTotal.name = res.Usage[1].name;
        // this.deviceUsageTotal.quantity = res.Usage[1].quantity;
        // this.deviceUsageTotal.unitprice = res.Usage[1].unitprice;
        // this.deviceUsageTotal.amount = res.Usage[1].amount;
        this.show_Doc_Info = true;
        
        this.ngxService.stop();
      }
    });
  }

  ngOnInit() {
  }

  generatePDF(rowData) {
    this.getMspDocParam = {
      ...this.getMspDocParam,
      DocId: rowData.DocId,
    };
    this.store.dispatch(new fromFeature.ReadMspPaymentDocument({ ...this.getMspDocParam }));
    this.docDetailInfo = {
      Company: rowData.Company,
      DocNo: rowData.DocNo,
      MonthYear: rowData.MonthYear,
      DocDate: this.formatDate(rowData.GenerateTime),
      Period: rowData.PeriodPDFFormat,
      DocStartDay: rowData.DocStartDay,
      DocEndDay: rowData.DocEndDay,
      DocType: rowData.DocType,
      PaymentType: rowData.PaymentType,
      isDistributor: rowData.IsDistributor,
      GenerateTime: rowData.GenerateTime,
      CorrNo: rowData.CorrNo,
    };
    this.ngxService.start();
    const div = document.getElementById("captureBillingPDF");
    if (!div) {
      console.error("captureBillingPDF element not found");
      this.ngxService.stop();
      return;
    }
    div.style.width = "1100px";

    const options = {
      background: "white",
      scale: 2,
      windowWidth: 1100,
      allowTaint: true,
      useCORS: true,
      dpi: 120,
    };
    setTimeout(() => {
      const isEllipsisActive = (el) => {
        return (el.offsetHeight < el.scrollHeight);
      }
      const elements = document.querySelectorAll('#captureDocPDF .ui-treetable .ui-treetable-tbody tr .rowDataName');
      elements.forEach((el) => {
        if (isEllipsisActive(el)) {
          el.classList.add('ellipsis');
        }
      });
      html2canvas(div, options).then((canvas) => {
        var leftHeight = canvas.height;
        var a4Width = 595.28;
        var a4Height = 841.89;
        var a4HeightRef = Math.floor((canvas.width / a4Width) * a4Height);
        var position = 0;
        var pageData = canvas.toDataURL("image/jpeg", 1.0);
        var pdf = new jsPDF("p", "pt", "a4");
        var index = 1, canvas1 = document.createElement("canvas"), height;
        pdf.setDisplayMode("fullwidth", "continuous", "FullScreen");
        var pdfName = this.docNumber;

        function createImpl(canvas) {
            if (leftHeight > 0) {
                index++;
                var checkCount = 0;
                if (leftHeight > a4HeightRef) {
                    var i = position + a4HeightRef;
                    for (i = position + a4HeightRef; i >= position; i--) {
                        var isWrite = true;
                        for (var j = 0; j < canvas.width; j++) {
                            var c = canvas.getContext("2d").getImageData(j, i, 1, 1).data;
                            if (c[0] != 0xff || c[1] != 0xff || c[2] != 0xff) {
                                isWrite = false;
                                break;
                            }
                        }
                        if (isWrite) {
                            checkCount++;
                            if (checkCount >= 10) {
                                break;
                            }
                        } else {
                            checkCount = 0;
                        }
                    }
                    height = Math.round(i - position) || Math.min(leftHeight, a4HeightRef);
                    if (height <= 0) {
                        height = a4HeightRef;
                    }
                } else {
                    height = leftHeight;
                }

                canvas1.width = canvas.width;
                canvas1.height = height;

                var ctx = canvas1.getContext("2d");
                ctx.drawImage(canvas, 0, position, canvas.width, height, 0, 0, canvas.width, height);

                if (position != 0) {
                    pdf.addPage();
                }
                pdf.addImage(canvas1.toDataURL("image/jpeg", 1.0), "JPEG", 0, 0, a4Width, (a4Width / canvas1.width) * height);
                leftHeight -= height;
                position += height;

                // Debug logs for troubleshooting
                console.log(`Position: ${position}, Height: ${height}, Left Height: ${leftHeight}`);

                if (leftHeight > 0) {
                    setTimeout(createImpl, 0, canvas);
                } else {
                  if (rowData.DocType === 1) {
                    pdf.save("PPC_Invoice_" + pdfName + ".pdf");
                  } else {
                    pdf.save("PPC_PO_" + pdfName + ".pdf");
                  }
                }
            }
        }

        if (leftHeight < a4HeightRef) {
            pdf.addImage(pageData, "JPEG", 0, 0, a4Width, (a4Width / canvas.width) * leftHeight);
            if (rowData.DocType === 1) {
              pdf.save("PPC_Invoice_" + pdfName + ".pdf");
            } else {
              pdf.save("PPC_PO_" + pdfName + ".pdf");
            }
        } else {
            try {
                pdf.deletePage(0);
                setTimeout(createImpl, 0, canvas);
            } catch (err) {
                console.error("Error creating PDF:", err);
            }
        }
      });

      this.ngxService.stop();
    }, 1000);
  }

  formatDate(dateString) {
    const date = new Date(dateString);
    const month = ('0' + (date.getMonth() + 1)).slice(-2);
    const day = ('0' + date.getDate()).slice(-2);
    const year = date.getFullYear();
    return `${month}/${day}/${year}`;
  }

  ngOnDestroy(): void {
    this.componentDestroyed.next(undefined);
    this.componentDestroyed.complete();
  }
}
